var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Translate } from "../I18N";









export const DocumentCounter = (props) => {
  const {
    totalConnectionsCount,
    selectedEntitiesCount,
    entityListCount,
    entityTotal,
    hitsTotalRelation
  } = props;
  const totalEntitiesValue = /*#__PURE__*/_jsx("b", {}, void 0, " ", `${entityTotal}${hitsTotalRelation === 'gte' ? '+' : ''}`, " ");
  const entityCounter = /*#__PURE__*/
  React.createElement(React.Fragment, null,
  selectedEntitiesCount > 0 && /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("b", {}, void 0, " ", selectedEntitiesCount, " "), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "selected of")
  ), /*#__PURE__*/

  _jsx("b", {}, void 0, " ", entityListCount, " "), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "shown of"),
  totalEntitiesValue, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "entities")
  );

  const connectionsCounter = /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("b", {}, void 0, totalConnectionsCount, " "), /*#__PURE__*/
  _jsx(Translate, {}, void 0, "relationships"), ", ", /*#__PURE__*/_jsx("b", {}, void 0, totalEntitiesValue, " "), /*#__PURE__*/
  _jsx(Translate, {}, void 0, "entities")
  );


  return /*#__PURE__*/_jsx("span", {}, void 0, totalConnectionsCount === undefined ? entityCounter : connectionsCounter);
};